<template>
  <div>
    <div v-if="isMobile">
      <div>
        <div v-if="items.length > 5 && isActive">
          <!-- кнопка открытия диалога -->
          <div @click="openFacet(facetname)" class="sm-facet_tile">
            <div class="sm-facet__title">
              <span class="sm-facet__title__name">{{ title }}</span>
            </div>
            <div class="sm-facet__chosen">{{ selected_facet_info }}</div>
            <svg width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg" class="sm-facet_tile__icon"><use xlink:href="#chevron-right"></use></svg>
          </div>

          <div v-if="currentOpenFacet === facetname" class="sm-screen">
            <div class="sm-screen__actions sm-screen__actions_top">
              <div class="sm-screen__slot sm-screen__slot_l">
                <button @click="closeFacet" class="sm-screen__button sm-screen__button_f-small">
                  <svg width="5" height="9" viewBox="0 0 5 9" xmlns="http://www.w3.org/2000/svg" class="sm-screen__icon sm-screen__icon__arrow-left"><use xlink:href="#f-small-back"></use>
                  </svg>
                  Назад
                </button>
              </div>
              <div class="sm-screen__slot">
                <span class="sm-screen__title">{{ title }}</span></div>
              <div class="sm-screen__slot sm-screen__slot_r">
                <button @click="toggleOpenFacets" class="sm-screen__button sm-screen__button_f-small">
                  Закрыть
                </button>
              </div>
            </div>

            <div class="sm-screen__content sm-screen__content_indented">
              <facet-common v-if="isActive"
                  :title="title"
                  :items="items"
                  :facetname="facetname"
                  :queryparam="queryparam"
                  :active="active"
                  :type="type"
              ></facet-common>
            </div>

            <div class="sm-screen__actions sm-screen__actions_bottom">
              <button @click="closeFacet" class="sm-screen__button sm-screen__button_stretch">
                Выбрать
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <facet-common v-if="isActive"
              :title="title"
              :items="items"
              :facetname="facetname"
              :queryparam="queryparam"
              :active="active"
              :type="type"
          ></facet-common>
        </div>
      </div>
    </div>
    <div v-else>
      <facet-common v-if="isActive"
                    :title="title"
                    :items="items"
                    :facetname="facetname"
                    :queryparam="queryparam"
                    :active="active"
                    :type="type"
      ></facet-common>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import FacetCommon from"./facet-common.vue";

export default {
  name: "facet-common-mobile-desktop",
  props: [
      "title",
      "items",
      "facetname",
      "queryparam",
      "active",
      "type" // common|yesnow|color
  ],
  computed: {
    ...mapGetters("search", ["currentOpenFacet", "selectedFacets", "isMobile"]),
    isActive: function () {
      return (this.items.length > 0 && this.active);
    },
    selected_facet_info: function () { // инф. о выбранных фасетах
      const selected = this.getCheckedArr(this.facetname);

      if(selected.length === 1) {
        return selected[0];
      } else if(selected.length > 1) {
        return selected.length + " выбрано";
      }
      return '';
    }
  },
  methods: {
    ...mapActions("search", ["setCurrentOpenFacet", "toggleOpenFacets"]),
    getCheckedArr(name) {
      let facet = this.selectedFacets.filter(function (item) {
        return item.name === name;
      });
      return (facet.length) ? facet[0].value : [];
    },
    openFacet(facetname) {
      this.setCurrentOpenFacet(facetname)
    },
    closeFacet() {
      this.setCurrentOpenFacet('')
    },
  },
  components: {
    FacetCommon
  }
}
</script>